// extracted by mini-css-extract-plugin
module.exports = {"collapse":"styles_collapse__SgYg8","panel":"styles_panel__a9eGM"};